import { Text } from "appworks/graphics/pixi/text";
import { GlowFilter, OutlineFilter } from "pixi-filters";
import { TextStyle } from "pixi.js";

export function ApplyFowlPlayTextStyling(text: Text,strokeSize:number=1) {
    const style = text.style as TextStyle;

    // gradient fill
    style.fill = [0xFF0000, 0xFFFF00];
    style.fillGradientStops = [0, 1];

    // stroke 1
    const stroke1 = new OutlineFilter(strokeSize, 0xF9E400);
    text.filters.push(stroke1);

    // stroke 2
    const stroke2 = new OutlineFilter(strokeSize, 0x000000);
    text.filters.push(stroke2);

    // stroke 3
    const stroke3 = new OutlineFilter(strokeSize, 0x00C6FF);
    text.filters.push(stroke3);

    // outer glow
    const glow = new GlowFilter({
        distance: 3,
        outerStrength: 20,
        color: 0x000000,
        quality: 0.5
    });
    text.filters.push(glow);
}
